<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="supplierSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    :value-key="itemName"
                    placeholder="请输入名称">
    <template slot-scope="{item}">
      <a :title="item.custName" style="text-decoration:none">{{item.custName}}</a>
    </template>
  </qx-auto-complete>
</template>

<script>
/**
 * @Author: 菩萨蛮
 * @Date: 2020/9/3 4:16 下午
 * @Description: 客户查询组件
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import SearchObj from 'Components/common/search/SearchObj';
import AutoComplete from '../../../mixins/common/AutoComplete';

export default {
  name: 'CustomerAutoComplete',
  mixins: [AutoComplete],
  data() {
    return {
      url: '/customer/info?custName=',
      itemName: 'custName'
    };
  },
  methods: {
    async selectItem(item) {
      if (item !== null) {
        this.$emit('update:value', item[this.itemName]);
        this.$emit('setValue', {
          ...item,
          index: this.index
        });
        this.$emit('setTags', this.getCustomerSearchValue(item));
      }
    },
    getCustomerSearchValue(item) {
      return new SearchObj(
        'custId', '客户名称', item.id, 'customer', item.custName
      ).tags;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
